import type { ReactNode } from "react";
import { Flex } from "@jsq/ds/core";
import { Sizes } from "@jsq/ds/styles";
import * as styles from "./styles_vanilla.css";

export const WizardFooterBar = ({
  children,
  fullWidth = false,
}: {
  children: ReactNode;
  fullWidth?: boolean;
}) => (
  <Flex
    className={fullWidth ? styles.footerInnerWide : styles.footerInner}
    justifyContent="flex-end"
    gap={Sizes.SM}
  >
    {children}
  </Flex>
);
